
@if (invitation; as i) {
  {{ ((i.shopItem?.price ?? []) | price | async) }}
  <app-currency-changer
    [price]="i.shopItem?.price ?? []"
    [type]="CurrencyChangerType.ICON"
    [appendTo]="'body'">
  </app-currency-changer>
}